interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizes = { sm: '1rem', md: '1.5rem', lg: '2.5rem' };

export function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  const s = sizes[size];
  return (
    <span
      role="status"
      aria-label="Carregando"
      className={`spinner ${className}`}
      style={{ width: s, height: s }}
    />
  );
}
